import { KioskStateType } from "../../KioskReducer"
import { ActionType } from "../../Actions"
import { VEILLE_CHANGE } from "../../Actions/Kiosk/veilleChangeAction";
import { VEILLE_RESET } from '../../Actions/Kiosk/veilleResetAction';
import storeState, { emptyState } from "../../../utils/storeState";
import { storageKeyVeille } from "../../../model/StorageKeys";

export default function veilleReducer(
  state: KioskStateType,
  action: ActionType
): KioskStateType {
  switch(action.type) {
    case VEILLE_CHANGE:
      storeState(storageKeyVeille, action.payload.veille);
      return {
        ...state,
        veille: action.payload.veille
      }
    case VEILLE_RESET:
      emptyState(storageKeyVeille);
      return {
        ...state,
        veille: null
      }
    }

  return state;
}
